
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"section"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"_id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"section"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lessonsLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inProgress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"length"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"progress"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lessonId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sectionOrder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lessonOrder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastTimecode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videoTime"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"lessonInProgressId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lessonInProgressOrder"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lessonProgressPercent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locked"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"order"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewURL"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lessons"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videoURL"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"type"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videoLength"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"parentLessonId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"inProgress"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"completed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"locked"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"track"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"previewURL"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hostName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unloackCode"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userNote"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"body"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"userId"},"arguments":[],"directives":[]}]}}]}}]}}]}}],"loc":{"start":0,"end":611}};
    doc.loc.source = {"body":"query section($_id: String, $type: String) {\n\tsection(_id: $_id, type: $type) {\n\t\t_id\n\t\tname\n\t\tslug\n\t\tlessonsLength\n\t\tinProgress\n\t\tlength\n\t\tprogress {\n\t\t\t_id\n\t\t\tuserId\n\t\t\tlessonId\n\t\t\tsectionOrder\n\t\t\tlessonOrder\n\t\t\tlastTimecode\n\t\t\tvideoTime\n\t\t}\n\t\tlessonInProgressId\n\t\tlessonInProgressOrder\n\t\tlessonProgressPercent\n\t\tcompleted\n\t\tlocked\n\t\torder\n\t\tpreviewURL\n\t\tlessons {\n\t\t\t_id\n\t\t\tname\n\t\t\tdescription\n\t\t\ttype\n\t\t\tstatus\n\t\t\tvideoURL\n\t\t\ttype\n\t\t\tvideoLength\n\t\t\tparentLessonId\n\t\t\tinProgress\n\t\t\tcompleted\n\t\t\tlocked\n\t\t\ttrack\n\t\t\tpreviewURL\n\t\t\thostName\n\t\t\tunloackCode\n\t\t\tuserNote {\n\t\t\t\t_id\n\t\t\t\tbody\n\t\t\t\tuserId\n\t\t\t}\n\t\t}\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["section"] = oneQuery(doc, "section");
        
